import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_GENERAL_SETTINGS_ROUTE_NAME = Symbol('admin.general-settings');
export const TRANSLATION_GROUP_GENERAL_SETTINGS = Symbol('general-settings');

export const ADMIN_GENERAL_SETTINGS_PERMISSIONS = {
  PROJECTSETTINGS_EDIT: new Permission(PermissionsList.admin.PROJECTSETTINGS_EDIT),
};

export const GENERAL_SETTINGS_INNER_CARD_CLASSES = 'mb-4 rounded-t-none border-t-0';
